import { formatearFecha } from "../../helpers/functionHelpers";
export const emailActualizacionCita = (data) =>
{
return `
    <p>Has recibido un nuevo mensaje autom&aacute;tico de Sanfer.</p>
  <p>La cita con el folio <strong>${data.folio}</strong> ha sido actualizada.</p>
  <p>Los nuevos datos de la cita son:</p>
  <ul>
    <li><strong>Almacén:</strong> ${data.almacenDescripcion}</li>
    <li><strong>Fecha:</strong> ${formatearFecha(data.fechaRsv)}</li>
    <li><strong>Hora de inicio:</strong> ${data.dataIni}</li>
    <li><strong>Hora final:</strong> ${data.dataFin}</li>
  </ul>
  <p>Gracias.<br>Equipo Sanfer.</p>
      `;
}